import { ErrorBoundary } from 'modules/error';
import { Product, Team } from 'teams';

import { usePanelContext } from '../../contexts/Panel';
import { PanelView } from '../../constants';
import { PanelViewDetail } from './PanelViewDetail';
import { PanelViewList } from './PanelViewList';

const getPanelView = (view: PanelView) => {
  switch (view) {
    case PanelView.Detail:
      return PanelViewDetail;
    case PanelView.List:
      return PanelViewList;
    default:
      return PanelViewList;
  }
};

export const PanelBody = () => {
  const { panelView } = usePanelContext();
  const View = getPanelView(panelView);

  return (
    <ErrorBoundary teamName={Team.CONTENT_TEAM} productName={Product.MOVABLE_INK}>
      <View />
    </ErrorBoundary>
  );
};
